import React from 'react';
import PropTypes from 'prop-types';

import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './styles.scss';
import ProjectItem from './project-item';
import { useTranslation } from 'react-i18next';

Project.propTypes = {
    data: PropTypes.array,
};

const breakpoints = {
    0: { slidesPerView: 1.3 },
    576: { slidesPerView: 2.2 },
    991: { slidesPerView: 3.4 },
    1400: { slidesPerView: 4.4 },
};

function Project(props) {
    const { data } = props;
    const { t } = useTranslation();

    const half = Math.ceil(data.length / 2);
    const rowOne = data.slice(0, half);
    const rowTwo = data.slice(half);

    return (
        <section id="portfolio" className="tf-section tf-project">
            <div className="container">
                <div className="tf-title mb-50" data-aos="fade-up" data-aos-duration="800">
                    <p className="h8 sub-title">{t('portfolio')}</p>
                    <h2 className="title">{t('portfolio-title')}</h2>
                    <p className="portfolio-lead">{t('portfolio-desc')}</p>
                </div>
            </div>

            <div className="container-fluid">
                <Swiper
                    className="swiper-portfolio s1"
                    modules={[Autoplay]}
                    spaceBetween={18}
                    breakpoints={breakpoints}
                    loop
                    autoplay={{
                        delay: 1,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    speed={4500}
                >
                    {rowOne.map((item) => (
                        <SwiperSlide key={item.id}>
                            <ProjectItem item={item} />
                        </SwiperSlide>
                    ))}
                </Swiper>

                <Swiper
                    className="swiper-portfolio s1 mt-30"
                    modules={[Autoplay]}
                    spaceBetween={18}
                    breakpoints={breakpoints}
                    loop
                    autoplay={{
                        delay: 1,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                        reverseDirection: true,
                    }}
                    speed={4500}
                >
                    {rowTwo.map((item) => (
                        <SwiperSlide key={item.id}>
                            <ProjectItem item={item} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}

export default Project;
